import { BaseComponent, define, api } from 'core';

export class ProductRecommendations extends BaseComponent {
  connectedCallback() {
    super.connectedCallback();
    this._sectionId = this.dataset.sectionId;
    this._url = this.dataset.url;
    if (this._sectionId && this._url) this._load();
  }

  async _load() {
    try {
      const html = await api.renderSection(this._sectionId, { url: this._url });
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      const live = this.querySelector('[data-recommendations]');
      if (fresh && live) live.innerHTML = fresh.innerHTML;
    } catch (_error) {

    }
  }
}

define('product-recommendations', ProductRecommendations);
